<template>
<div class="nebPillSelectPill"
  :class="{isNotSelected}"
  :style="style"
  @click="onClick"
>
  <span class="nebPillSelectPill-label">{{ label }}</span>
</div>
</template>

<script>
export default {
  name: 'NebPillSelectPill',

  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: null
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isNotSelected: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    style () {
      if (this.isSelected) {
        return {
          borderColor: this.color || 'initial',
          backgroundColor: `${this.color}20` || 'transparent',
          color: this.color || 'initial'
        }
      } else {
        return {
          borderColor: this.color || 'initial',
          backgroundColor: 'transparent',
          color: this.color || 'initial'
        }
      }
    }
  },

  methods: {
    onClick () {
      this.$emit('click', this.value)
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebPillSelectPill {
  box-sizing: border-box;
  overflow: hidden;
  padding: 5px 10px;
  border-radius: 2px;
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 7px;

  &:not(:last-child) {
    margin-right: 7px;
  }

  &-label {
    font-size: 12px;
    font-family: $defaultFont;
  }

  &.isNotSelected {
    opacity: 0.5;
  }
}
</style>
